'use strict'

import {
  serverApi
} from '@/server';

/**
 * 高管列表
 *
 * @author nick
 *
 *
 * @returns {Promise}
 *
 */


export default {

  personEnterpriseInformation(formData) {
    let url = `/person-enterprise-information`;
    return serverApi.get(formData, url);
  },

  personEnterpriseShowIdcard(id) {
    let url = `/person-enterprise-show-idcard/${id}`;
    return serverApi.get({}, url);
  },

  personEnterpriseShowPhone(id) {
    let url = `/person-enterprise-show-phone/${id}`;
    return serverApi.get({}, url);
  },


}

